module.exports = __webpack_public_path__ + "media/pedido.ac18a014.mp3";